import { usePlaybackTimerPause } from "../playback";

export default function useUpdatePanelBuffering(isBuffering: boolean) {
  usePlaybackTimerPause(isBuffering);
}
